import { TASKS_NUMBER_LIMIT, GLOBAL_TASK_MONTHS_NUMBER_LIMIT, REGULAR_TASK_MONTHS_NUMBER_LIMIT, LABEL_NUMBER_LIMIT } from '../../constants/server';
import { DEFAULT_LANGUAGE } from '../../constants/languages';

class AuthUser {
  // utils shallowCompare only works for authStateChanged
  // don't add object data type without using of deepCompare
  constructor(authUser = {}) {
    this.uid = authUser.uid || '';
    this.email = authUser.email || '';
    this.emailVerified = authUser.emailVerified || false;
    this.isProviderPassword = authUser.isProviderPassword || !!authUser.password || false;
    this.fullName = authUser.fullName || '';
    this.language = authUser.language || DEFAULT_LANGUAGE;
    this.disableTasksDone = authUser.disableTasksDone || false;
    this.disableAdviceShow = authUser.disableAdviceShow || false;
    this.adviceShowedAt = authUser.adviceShowedAt || null;
    this.showGlobalTasksAsList = authUser.showGlobalTasksAsList || false;
    this.taskNumberLimit = authUser.taskNumberLimit || TASKS_NUMBER_LIMIT;
    this.globalTaskMonthsNumberLimit = authUser.globalTaskMonthsNumberLimit || GLOBAL_TASK_MONTHS_NUMBER_LIMIT;
    this.regularTaskMonthsNumberLimit = authUser.regularTaskMonthsNumberLimit || REGULAR_TASK_MONTHS_NUMBER_LIMIT;
    this.labelNumberLimit = authUser.labelNumberLimit || LABEL_NUMBER_LIMIT;
  }

  getAuthUser(serverModel) {
    this.uid = serverModel.extId || '';
    this.email = serverModel.email || '';
    this.emailVerified = serverModel.isVerified || false;
    this.isProviderPassword = !!serverModel.password || false;
    this.fullName = serverModel.fullName || `${serverModel.firstName} ${serverModel.lastName}` || '';
    this.language = serverModel.language || DEFAULT_LANGUAGE;
    this.disableTasksDone = serverModel.settings ? serverModel.settings.disableTasksDone : false;
    this.disableAdviceShow = serverModel.settings ? serverModel.settings.disableAdviceShow : false;
    this.adviceShowedAt = serverModel.settings ? serverModel.settings.adviceShowedAt : null;
    this.showGlobalTasksAsList = serverModel.settings ? serverModel.settings.showGlobalTasksAsList : false;
    this.taskNumberLimit = serverModel.settings ? serverModel.settings.taskNumberLimit || TASKS_NUMBER_LIMIT : TASKS_NUMBER_LIMIT;
    this.globalTaskMonthsNumberLimit = serverModel.settings
      ? serverModel.settings.globalTaskMonthsNumberLimit || GLOBAL_TASK_MONTHS_NUMBER_LIMIT
      : GLOBAL_TASK_MONTHS_NUMBER_LIMIT;
    this.regularTaskMonthsNumberLimit = serverModel.settings
      ? serverModel.settings.regularTaskMonthsNumberLimit || REGULAR_TASK_MONTHS_NUMBER_LIMIT
      : REGULAR_TASK_MONTHS_NUMBER_LIMIT;
    this.labelNumberLimit = serverModel.settings ? serverModel.settings.labelNumberLimit || LABEL_NUMBER_LIMIT : LABEL_NUMBER_LIMIT;
    return this;
  }
}

export default AuthUser;
